import { isClientSide } from "@socar-inc/web-frontend-libraries";

export const clientSideOnly = (callback: () => void) => {
  if (isClientSide) {
    callback();
  }
};
